import React, { useContext, useEffect, useState } from 'react'
import { ContextUserInfo } from '../MainPanel';
import { ContextNotification, severitys } from '../../../App';
import ConfirmationDialog from '../../../Components/ConfirmationDialog';
import { MdDelete } from 'react-icons/md';
import { IconButton, Tooltip } from '@mui/material';
import guestRequestApi from '../../../api/guestRequestApi';
import fileAttachmentApi from '../../../api/fileAttachmentApi';

const DeleteAttachment = ({ id, refreshGrid }) => {
    const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
    const { open, setOpen } = useContext(ContextNotification);
    const [openDelete, setOpenDelete] = useState(false);
    useEffect(() => {

    }, []);
    const handleOpenDelete = (id) => {
        setOpenDelete(true);
    };
    const handleDelete = () => {
        fileAttachmentApi.Delete(id).then((res) => {
            if (res.data.success) {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                refreshGrid(true)
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
            else {
                setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
            }
        }
        ).finally(() => setOpenDelete(false));
    };
    return (
        <>
            <Tooltip title="حذف" placement="top">
                <IconButton onClick={() => {
                    handleOpenDelete(id)
                }}>
                    <MdDelete style={{ color: '#C7253E' }} />
                </IconButton>
            </Tooltip>
            <ConfirmationDialog
                open={openDelete}
                handleClose={() => setOpenDelete(false)}
                func={handleDelete}
                title={"آیا از حذف این آیتم اطمینان دارید؟"}
            />
        </>
    )
}

export default DeleteAttachment